module.exports = __webpack_public_path__ + "static/img/2.0fd4e08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/2.png
// module id = 8c4i
// module chunks = 0